import { render, staticRenderFns } from "./CourseDetails.vue?vue&type=template&id=09b65ea8"
import script from "./CourseDetails.vue?vue&type=script&lang=js"
export * from "./CourseDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports